<template>
 <NConfigProvider>
  <LawReport/>
 </NConfigProvider>
</template>

<script>
import LawReport from './components/LawReport.vue'
import { NConfigProvider } from 'naive-ui';

export default {
  name: 'App',
  components: {
    LawReport,
    NConfigProvider
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
